import { AppDomainConfig } from "../envConfig";

import type { Organization, User } from "../model/app/propTypes";

export function getAdminOrgOrConfig(
  orgOrConfig: AppDomainConfig | null | Organization,
  otherOrgsOrConfigs: (AppDomainConfig | Organization)[],
  user: User,
) {
  if (
    !orgOrConfig &&
    user?.is_staff &&
    otherOrgsOrConfigs.some((cd) => {
      return cd.slug === "geopstest";
    })
  ) {
    return otherOrgsOrConfigs.find((cd) => {
      return cd.slug === "geopstest";
    });
  }
  return orgOrConfig;
}
